
import React, { Component } from 'react';
import { Modal, Col, ControlLabel, Form, FormGroup, FormControl, Button, ButtonToolbar } from 'react-bootstrap'
// import Select from 'react-select'
import FontAwesome from 'react-fontawesome'
import WorkdocStore from '../../stores/WorkdocStore'
var NotificationSystem = require('react-notification-system');

class InsurerEditModal extends Component {

  constructor(...args) {
    super(...args)
    this.state = this.initItem()
  }

  componentDidMount(){
    this._notificationSystem = this.refs.notificationSystem
  }

  initItem() {
    return  {
      address: "",
      bf_insurer_id: "",
      email: "",
      emcs: "",
      fax: "",
      name: "",
      out_of_business: "",
      short_name: "",
      tax_no: "",
      branch: "",
      tel: "",
      website: "",
      payment_condition: "",
      contact_name: "",
      contact_tel: "",
      other_remark: ""
    }
  }

  loadItemcode(item) {
    // console.log('loadItem', item)
    if (item !== null)
      this.setState(Object.assign(this.state, item))
    else
      this.setState(this.initItem());
  }

  onTextChange(field, e) {
    let state = this.state
    state[field] = e.target.value
    this.setState(state)
  }

  onSelectChange(value) {
    // let { catSelect } = this.state

    this.setState({ catSelect: value })
  }

  onDelClick() {
    let that = this
    let { bf_insurer_id } = this.state

    that.props.onAfterSubmit(bf_insurer_id);
    that.props.onHide()
    //console.log('postData',postData)
    // WorkdocStore.delInsurer(bf_insurer_id, function () {
    //   that.props.onAfterSubmit(bf_insurer_id);
    //   that.props.onHide()
    // })
  }

  onSaveClick() {
    let that = this
    let { bf_insurer_id,name,address,tel,fax,tax_no,branch,email,website,contact_name,contact_tel,payment_condition,other_remark,short_name } = this.state
    let postData = { 
      bf_insurer_id: bf_insurer_id,
      name: name,
      address: address, 
      tel: tel,
      fax: fax,
      tax_no: tax_no,
      branch: branch,
      email: email,
      website: website,
      contact_name: contact_name,
      contact_tel: contact_tel,
      payment_condition: payment_condition,
      other_remark: other_remark,
      short_name: short_name
    }
    bf_insurer_id = (bf_insurer_id===''?'new':bf_insurer_id)
    that.props.onAfterSubmit(postData);
    that.props.onHide()
    WorkdocStore.saveInsurer(bf_insurer_id,postData, function () {
      that._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'บันทึกเรียบร้อย',
        level: 'info',
        position: 'tc',        
      })
      that.props.onAfterSubmit(postData);
      that.props.onHide()
    }, function () {

    }) 
  }

  renderHeader() {
    return (
      <div className='row form-group'>
        <div className='col-md-12'>
          <div className='col-md-3'>
            ชื่อลูกค้า
        </div>
          <div className='col-md-6'>
            ที่อยู่
        </div>
          <div className='col-md-3'>
            เบอร์โทร
        </div>
        </div>
      </div>
    )
  }

  renderForm() {
    // let { name, address, tel } = this.state
    let {address,
      payment_condition,
      email,
      other_remark,
      fax,
      name,
      contact_name,
      contact_tel,
      tax_no,
      branch,
      tel,
      website,
      short_name
    } = this.state
    // let { catOptions } = this.props
    
    return (
      <Form horizontal>
        <FormGroup controlId='formCompanyName'>
          <Col componentClass={ControlLabel} md={2}>
            ชื่อบริษัทประกัน
          </Col>
          <Col md={10}>
            <FormControl 
              type='text' 
              value={name} 
              onChange={this.onTextChange.bind(this, 'name')}
            />
          </Col>
        </FormGroup>
        <FormGroup controlId='formCompanyShortName'>
          <Col componentClass={ControlLabel} md={2}>
            ชื่อย่อบริษัท
          </Col>
          <Col md={10}>
            <FormControl 
              type='text' 
              value={short_name} 
              onChange={this.onTextChange.bind(this, 'short_name')}
            />
          </Col>
        </FormGroup>
        <FormGroup controlId='formAddress'>
          <Col componentClass={ControlLabel} md={2}>
            ที่อยู่
          </Col>
          <Col md={10}>
            <FormControl 
              type='text' 
              value={address} 
              onChange={this.onTextChange.bind(this, 'address')}
            />
          </Col>
        </FormGroup>
        <FormGroup controlId='formTel'>
          <Col componentClass={ControlLabel} md={2}>
            เบอร์โทร
          </Col>
          <Col md={10}>
            <FormControl 
              type='text' 
              value={tel} 
              onChange={this.onTextChange.bind(this, 'tel')}
            />
          </Col>
        </FormGroup>
        <FormGroup controlId='formFax'>
          <Col componentClass={ControlLabel} md={2}>
            แฟกซ์
          </Col>
          <Col md={10}>
            <FormControl 
              type='text' 
              value={fax} 
              onChange={this.onTextChange.bind(this, 'fax')}
            />
          </Col>
        </FormGroup>
        <FormGroup controlId='formTax'>
          <Col componentClass={ControlLabel} md={2}>
            เลขที่ผู้เสียภาษี
          </Col>
          <Col md={10}>
            <FormControl 
              type='text' 
              value={tax_no} 
              onChange={this.onTextChange.bind(this, 'tax_no')}
            />
          </Col>
        </FormGroup>
        <FormGroup controlId='formBranch'>
          <Col componentClass={ControlLabel} md={2}>
            สาขา
          </Col>
          <Col md={10}>
            <FormControl 
              type='text' 
              value={branch} 
              onChange={this.onTextChange.bind(this, 'branch')}
            />
          </Col>
        </FormGroup>
        <FormGroup controlId='formEmail'>
          <Col componentClass={ControlLabel} md={2}>
            อีเมลล์
          </Col>
          <Col md={10}>
            <FormControl 
              type='text' 
              value={email} 
              onChange={this.onTextChange.bind(this, 'email')}
            />
          </Col>
        </FormGroup>
        <FormGroup controlId='formWebsite'>
          <Col componentClass={ControlLabel} md={2}>
            เว็บไซต์
          </Col>
          <Col md={10}>
            <FormControl 
              type='text' 
              value={website} 
              onChange={this.onTextChange.bind(this, 'website')}
            />
          </Col>
        </FormGroup>
        <FormGroup controlId='formContact'>
          <Col componentClass={ControlLabel} md={2}>
            ชื่อผู้ติดต่อ
          </Col>
          <Col md={4}>
            <FormControl 
              type='text' 
              value={contact_name} 
              onChange={this.onTextChange.bind(this, 'contact_name')}
            />
          </Col>
          <Col componentClass={ControlLabel} md={2}>
            เบอร์โทรผู้ติดต่อ
          </Col>
          <Col md={4}>
            <FormControl 
              type='text' 
              value={contact_tel} 
              onChange={this.onTextChange.bind(this, 'contact_tel')}
            />
          </Col>
        </FormGroup>
        <FormGroup controlId='formCredit'>
          <Col componentClass={ControlLabel} md={2}>
            เงื่อนไขการชำระเงิน/เครดิต
          </Col>
          <Col md={10}>
            <FormControl 
              type='text' 
              value={payment_condition} 
              onChange={this.onTextChange.bind(this, 'payment_condition')}
            />
          </Col>
        </FormGroup>
        <FormGroup controlId='formDetail'>
          <Col componentClass={ControlLabel} md={2}>
            รายละเอียดอื่นๆ
          </Col>
          <Col md={10}>
            <FormControl 
              type='text' 
              value={other_remark} 
              onChange={this.onTextChange.bind(this, 'other_remark')}
            />
          </Col>
        </FormGroup>
      </Form>  
      // <div className='row form-group'>
      //   <div className='col-md-12'>
      //     <div className='col-md-3' style={{ display: 'inline-flex' }}>
      //       <FormControl value={name} onChange={this.onTextChange.bind(this, 'name')} />
      //     </div>
      //     <div className='col-md-6' style={{ display: 'inline-flex' }}>
      //       <FormControl componentClass="textarea" value={address} onChange={this.onTextChange.bind(this, 'address')} />
      //     </div>
      //     <div className='col-md-3' style={{ display: 'inline-flex' }}>
      //       <FormControl value={tel} onChange={this.onTextChange.bind(this, 'tel')} />
      //     </div>
      //   </div>
      // </div>
    )
  }

  render() {
    let { show } = this.props
    let { bf_insurer_id } = this.state

    let title = ''
    if (bf_insurer_id === '') {
      title = 'เพิ่มบริษัทประกัน'
    } else {
      title = 'แก้ไขรายละเอียดบริษัทประกัน'
    }
    return (
      <div>
        <Modal show={show} enforceFocus={false} onHide={this.props.onHide} dialogClassName="midwidth-dialog">
          <Modal.Header closeButton>
            <Modal.Title>{title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>

            {this.renderForm()}
          </Modal.Body>
          <Modal.Footer>
            <ButtonToolbar className='pull-right'>
              {
                (title !== 'เพิ่มบริษัทประกัน') 
                &&
                (
                  <Button 
                    bsStyle={'danger'} 
                    onClick={this.onDelClick.bind(this)}
                  >
                    <FontAwesome name='trash' />&nbsp;ลบข้อมูล
                  </Button>
                )
              }
              <Button bsStyle={'primary'} onClick={this.onSaveClick.bind(this)}><FontAwesome name='save' />&nbsp;บันทึกข้อมูล</Button>
              <Button onClick={this.props.onHide}><FontAwesome name='close' />&nbsp;ยกเลิก</Button>
            </ButtonToolbar>
          </Modal.Footer>
        </Modal>
        <NotificationSystem ref="notificationSystem" />
      </div>  
    )
  }
}


export default InsurerEditModal;





// WEBPACK FOOTER //
// ./src/view/insurer/InsurerEditModal.js